export const measurementNotice = {
  cs: {
    title: "Měření návštěvnosti",
    text: "Používáme Google Analytics pro základní statistiky návštěvnosti. Analytické cookies jsou zapnuté automaticky; reklamní ukládání a personalizace jsou vypnuté. Do měření neposíláme GPS polohu zařízení, souřadnice mapy, konkrétní vybrané WC ani obsah formulářů. Google může z připojení odvodit přibližnou oblast návštěvy. Údaje o událostech uchováváme 14 měsíců.",
  },
  en: {
    title: "Audience measurement",
    text: "We use Google Analytics for basic visitor statistics. Analytics cookies are enabled automatically; advertising storage and personalization are disabled. We do not send device GPS coordinates, map coordinates, the specific toilet you select, or form contents to analytics. Google may infer an approximate region from your connection. Event data is retained for 14 months.",
  },
};
